
import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {musicXmlImportController} from '../services/MusicXmlImportController';
import {
  MAX_STEP,
  MusicXmlImportProgression as MusicXmlImportProgressionType,
  getErrorMessage,
} from '../models/ImportMusicxmlTypes';
import {BackEndService} from 'src/utils/BackEndService';
import {analyticsController} from 'src/modules/user/analytics/AnalyticsController';

@Component()
export default class MusicXmlImportProgression extends Vue {
  @Prop({default: 'mini'}) size!: 'mini' | 'normal';

  private dismissed = false;
  private showDetails = false;

  get containerClass() {
    if (this.size === 'mini' && !this.showDetails) {
      return 'import-progression-mini-circle';
    }

    return {
      'import-progression': true,
      'import-progression--mini': this.size === 'mini',
      'import-progression--normal': this.size === 'normal',
    };
  }

  get shouldShow() {
    if (this.size === 'normal') {
      return !!this.currentImport;
    }
    // Pour mini, on affiche seulement si pas dismissed et qu'il y a un import
    return !!this.currentImport && !this.dismissed;
  }

  get currentImport() {
    return musicXmlImportController.state.currentImport;
  }

  get isCompleted() {
    return this.currentImport?.step === 'COMPLETED';
  }

  get isFailed() {
    return this.currentImport?.step === 'FAILED';
  }

  get failedReason() {
    if (!this.currentImport) {
      return '';
    }

    return getErrorMessage({status: this.currentImport.failed_reason});
  }

  get currentImportLabel() {
    if (!this.currentImport) {
      return '';
    }

    return this.$t(`importMusicxmlSteps.labels.${this.currentImport.step}`) as string;
  }

  get currentImportDescription() {
    if (!this.currentImport) {
      return '';
    }

    return this.$t(`importMusicxmlSteps.descriptions.${this.currentImport.step}`) as string;
  }

  get progression() {
    if (!this.currentImport) {
      return 0;
    }
    return (MusicXmlImportProgressionType[this.currentImport?.step] / MAX_STEP) * 100;
  }

  get sendEmailLoading() {
    return musicXmlImportController.state.isSendEmailLoading;
  }

  private interval: number | undefined;
  mounted() {
    if (this.isCompleted || this.isFailed) {
      return;
    }

    this.interval = setInterval(() => {
      musicXmlImportController.fetch(true);
    }, 8000);
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  private toggleDetails() {
    if (this.size === 'mini') {
      this.showDetails = !this.showDetails;
    }
  }

  private handleClose() {
    if (this.size === 'mini') {
      this.showDetails = false;
      // On marque comme lu seulement si terminé ou échoué
      if (this.isCompleted || this.isFailed) {
        musicXmlImportController.read()?.then(() => {
          clearInterval(this.interval);
          this.dismissed = true;
          this.$emit('close');
        });
      }
    } else {
      this.dismissed = true;
      this.$emit('close');
      musicXmlImportController.read()?.then(() => {
        clearInterval(this.interval);
      });
    }
  }

  private handleViewVersion() {
    if (!this.currentImport || !this.currentImport.published_version) {
      return;
    }
    this.$router.push(
      `/song/version/${this.currentImport.published_version.id}/${this.currentImport.published_version?.piece.url_artist}/${this.currentImport.published_version?.piece.url_title}`
    );
    this.handleClose();
  }

  private handleSendEmail() {
    if (!this.currentImport) {
      return;
    }
    musicXmlImportController.sendEmail();
    this.handleClose();
  }
}
